<template>
  <div class="alert alert-warning" role="alert" v-if="nonDelivery.length">
    Недоставленные заказы:
    <span v-for="nonDeliveryItem in nonDelivery" class="mr-2">
      <router-link :to="{ name: 'order-edit', params: {orderId: nonDeliveryItem.Id}}">{{nonDeliveryItem.SferaNumber}}</router-link>
    </span>
  </div>
</template>
<script>
import { post } from '@/admin/services/api/http-utils';
import _ from 'lodash';

const url = `${process.env.VUE_APP_API_HOST}admin/delivery`;
const type = 'partner';

export default {
  props: {
    PartnerId: Number,
    existOrderIds: Array,
  },
  data() {
    return {
      nonDelivery: [],
    };
  },
  mounted() {
    this.getNonDelivery();
  },
  watch: {
    existOrderIds: 'getNonDelivery',
  },
  methods: {
    async getNonDelivery() {
      const { data } = await post(`${url}/non-delivery/${type}`, this.$props);
      this.nonDelivery = _.map(data, (o) => {
        return {
          Id: o.OrderCommonId,
          SferaNumber: o.SferaNumber,
        };
      });
    },
  },
};
</script>
